import { ForumTopicPost } from '../../../../models/forumTopicPost';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { getUser } from '../../../../service/user';
import { calculateDate } from '../../../../utils/date';

import styles from './PostItem.module.scss';
import UserImage from '../../../../components/UserImage/UserImage';

interface PropsForumTopicPost {
  forumTopicPost: ForumTopicPost;
}

const ForumTopicItem = ({ forumTopicPost }: PropsForumTopicPost) => {

  const navigate = useNavigate();
  const formattedDate = calculateDate(forumTopicPost.createdAt);
  const userId = forumTopicPost.userId;

  const {data:user} = useQuery(
    ['post', 'user', userId],
    () => getUser(userId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  return (
    <div className={styles.post} key={"post_"+forumTopicPost.id}>
      <div className={styles.postHeader}>
        <div className={styles.userContainer} onClick={() => navigate(`/user/${user.id}`)}>
          <UserImage style={styles.circleUser} path={user?.pathPhoto} name={user?.fullname}/>
          <span>{user?.fullname}</span>
        </div>
        <div className={styles.date}>
          {formattedDate}
        </div>
      </div>
      <p className={styles.description}>{forumTopicPost.post}</p>
    </div>
  )
}

export default ForumTopicItem;